import {useMemo} from 'react'
import {useSelector} from 'react-redux'
import {useAzubisWithAusbildungsplanModul} from '#hooks/store/useAzubisWithAusbildungsplanModul'
import {useUserInfo} from '#hooks/store/useUserInfo'

const canViewFromOthersSelector = state =>
  state.authentication.permissions.ausbildungsplan.viewAusbildungsplanFromOthers

export const useAusbildungsplanIds = userId => {
  const {allAzubis} = useAzubisWithAusbildungsplanModul()
  const userInfo = useUserInfo(userId)
  const canViewFromOthers = useSelector(canViewFromOthersSelector)

  return useMemo(() => {
    if (canViewFromOthers) {
      const azubi = allAzubis.find(x => x.id === userId) || null
      if (azubi && azubi.ausbildungsplanId) {
        return {
          ausbildungsplanId: azubi.ausbildungsplanId,
          aufbauAusbildungsplanId: azubi.aufbauAusbildungsplanId,
        }
      }
    } else if (userInfo) {
      return {
        ausbildungsplanId: userInfo.ausbildungsplanId,
        aufbauAusbildungsplanId: userInfo.aufbauAusbildungsplanId,
      }
    }
    return {ausbildungsplanId: '', aufbauAusbildungsplanId: undefined}
  }, [userInfo, userId])
}
